import axios from "axios";
import { camelizeKeys, snakeKeys } from "../util/view";

const axiosInstance = axios.create({ withCredentials: true });
axiosInstance.interceptors.response.use(
  config => {
    config.data = camelizeKeys(config.data);
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
axiosInstance.interceptors.request.use(
  config => {
    config.data = snakeKeys(config.data);
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
